module.exports = __webpack_public_path__ + "static/media/lamp.94b49c2a.svg";